import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[secondColumnHost]',
})
export class SecondColumnDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
